import { Relationship } from 'json-api';
import { Message } from 'src/app/core/resources/message.resource';
import { AtomResource } from '../../core/classes/atom-resource';
import { Constructor } from './constructor.type';

export interface ResourceWithMessages extends AtomResource {
  messages?: Message[];
  ownedMessages?: Message[];
  inheritedMessages?: Message[];
}

export type HasMessages = Constructor<ResourceWithMessages>;

export function WithMessages<T extends Constructor<AtomResource>>(
  Base: T
): HasMessages & T {
  class WithMessagesClass extends Base {
    @Relationship() messages?: Message[];

    get ownedMessages(): Message[] | undefined {
      return this.messages?.filter((message) => message.isAssociatedAt(this));
    }

    get inheritedMessages(): Message[] | undefined {
      return this.messages?.filter((message) => !message.isAssociatedAt(this));
    }
  }
  return WithMessagesClass;
}
